import type { FC } from 'react';
import { useState } from 'react';
import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Box,
  Card,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { numberToMillons } from 'src/utils/functions';
import Panel from '../../../components/global/Panel';
import PanelHeader from '../../../components/global/PanelHeader';
import PanelTitle from '../../../components/global/PanelTitle';
import PanelFilter from '../../../components/admin/PanelFilter';
import Scrollbar from '../../../components/admin/Scrollbar';
import TableCellHeaderBasic from '../../../components/global/TableCellHeaderBasic';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import { onGet } from '../../../store/actions/global';
import TableCellHeaderSum from '../../../components/global/TableCellHeaderSum';

const Proyeccion: FC<any> = ({ onGet: onGetExec }) => {
  const isMountedRef = useIsMountedRef();
  const defaultLimit = 10;
  const title = 'Proyección de Facturación';
  const [jfn, setJfn] = useState({
    data: [],
    resume: {
      operaciones: 0,
      facturacion: 0,
      tuberia: 0,
      remesa: 0,
      proyeccion: 0,
      meta: 0,
      avance: 0,
    },
    pages: { total: 0, current: 0, limit: 0 },
  });
  const [valuesFilter, setValuesFilter] = useState({ year: null, month: null });

  const headers = [
    '',
    'Operaciones',
    'Facturación',
    'Monto',
    'Monto',
    'Monto',
    'Monto',
    'Reto',
  ];

  const onSubmit = async (values) => {
    if (isMountedRef.current) {
      setValuesFilter(values);
      const response = await onGetExec({
        url: '/dashboard/proyeccion',
        body: { ...values, limit: defaultLimit },
      });
      setJfn(response?.jfn);
    }
  };

  const handleChangePage = async (event: unknown, page: number) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/proyeccion/detail',
      body: { year, month, limit: Number(jfn.pages.limit), page, type: 'JFN' },
    });
    setJfn(response);
  };

  const handleChangeRowsPerPage = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/proyeccion/detail',
      body: {
        year,
        month,
        limit: Number(event.target.value),
        page: 0,
        type: 'JFN',
      },
    });
    setJfn(response);
  };

  return (
    <Panel>
      <PanelHeader>
        <PanelTitle
          title={title}
          subTitlePrim="Dashboard"
          subTitleSec={title}
        />
      </PanelHeader>
      <PanelFilter onSubmit={onSubmit} yearMonth />
      <Box pt={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <Scrollbar>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCellHeaderBasic
                        width="250px"
                        style={{ background: '#043263', border: 0 }}
                      >
                        EQUIPO JEFE DE NEGOCIO
                      </TableCellHeaderBasic>
                      <TableCellHeaderBasic
                        colSpan={2}
                        align="center"
                        style={{ background: '#043263', border: 0 }}
                      >
                        MES ACTUAL
                      </TableCellHeaderBasic>
                      <TableCellHeaderBasic
                        colSpan={1}
                        align="center"
                        style={{ background: '#043263', border: 0 }}
                      >
                        TUBERIA
                      </TableCellHeaderBasic>
                      <TableCellHeaderBasic
                        colSpan={1}
                        align="center"
                        style={{ background: '#043263', border: 0 }}
                      >
                        REMESA
                      </TableCellHeaderBasic>
                      <TableCellHeaderBasic
                        colSpan={1}
                        align="center"
                        style={{ background: '#7b7b7b', border: 0 }}
                      >
                        PROYECCION CIERRE
                      </TableCellHeaderBasic>
                      <TableCellHeaderBasic
                        colSpan={1}
                        align="center"
                        style={{ background: '#7b7b7b', border: 0 }}
                      >
                        META RETO
                      </TableCellHeaderBasic>
                      <TableCellHeaderBasic
                        width="100px"
                        style={{ background: '#2f74b5', border: 0 }}
                      >
                        % Meta
                      </TableCellHeaderBasic>
                    </TableRow>
                    <TableRow>
                      {headers.map((header, index) => {
                        const key = `h-${index}`;
                        let bgColor = '#bfbfbf';
                        let align:
                        | 'inherit'
                        | 'left'
                        | 'center'
                        | 'right'
                        | 'justify' = 'left';
                        if (index === 0) bgColor = '#043263';
                        if (index === 7) bgColor = '#2f74b5';
                        if (index !== 0) {
                          align = 'center';
                        }
                        const color = index === 0 || index === 7 ? 'white' : '#043263';
                        return (
                          <TableCellHeaderBasic
                            key={key}
                            style={{ background: bgColor, color }}
                            align={align}
                          >
                            {header}
                          </TableCellHeaderBasic>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody
                    style={{
                      background: 'white',
                      border: '1px',
                      borderColor: 'red',
                    }}
                  >
                    {jfn.data.map((item) => (
                      <TableRow key={item.jfn}>
                        <TableCell>{item.jfn}</TableCell>
                        <TableCell align="center">{item.operaciones}</TableCell>
                        <TableCell align="right">
                          {numberToMillons(item.facturacion)}
                        </TableCell>
                        <TableCell align="right">
                          {numberToMillons(item.tuberia)}
                        </TableCell>
                        <TableCell align="right">
                          {numberToMillons(item.remesa)}
                        </TableCell>
                        <TableCell align="right">
                          {numberToMillons(item.proyeccion)}
                        </TableCell>
                        <TableCell align="right">
                          {numberToMillons(item.meta)}
                        </TableCell>
                        <TableCell align="center">
                          {item.avance}
                          %
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableHead>
                    <TableRow>
                      <TableCellHeaderSum>Total</TableCellHeaderSum>
                      <TableCellHeaderSum align="center">
                        {jfn.resume.operaciones}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="right">
                        {numberToMillons(jfn.resume.facturacion)}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="right">
                        {numberToMillons(jfn.resume.tuberia)}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="right">
                        {numberToMillons(jfn.resume.remesa)}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="right">
                        {numberToMillons(jfn.resume.proyeccion)}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="right">
                        {numberToMillons(jfn.resume.meta)}
                      </TableCellHeaderSum>
                      <TableCellHeaderSum align="center">
                        {jfn.resume.avance}
                        %
                      </TableCellHeaderSum>
                    </TableRow>
                  </TableHead>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 15, 20]}
                        labelRowsPerPage="Registros por página"
                        labelDisplayedRows={({ from, to, count }) => `${from} al ${to} de ${count}`}
                        count={jfn.pages.total}
                        page={jfn.pages.current}
                        rowsPerPage={jfn.pages.limit}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </Scrollbar>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Panel>
  );
};

export default connect(null, {
  onGet,
})(Proyeccion);
